import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: Lato-Regular, sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n  padding-top: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: Lato-Regular, sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 0px ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  cursor: pointer;\n  border: 0;\n  background: none;\n  font-size: 18px;\n  color: #333;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: flex;\n  margin-top: 0.25em;\n  width: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 13px ", " ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  height: fit-content;\n  margin: 10px;\n  overflow: hidden;\n  width: fit-content;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Icon from '../../icon';
import { faTimes } from '../../icon/sets/regular';
import { faExclamationCircle, faInfoCircle, faCheck, faExclamationTriangle } from '../../icon/sets/solid';
var Wrapper = styled.div(_templateObject(), function (p) {
  return p.theme.white;
}, function (p) {
  return p.theme.spacing(0.5);
}, function (p) {
  return p.theme[p.brand];
});
var InnerPaddedWrapper = styled.div(_templateObject2(), function (p) {
  return p.theme.spacing(2);
}, function (p) {
  return p.theme.spacing(2);
});
var SideWrapper = styled.div(_templateObject3(), function (p) {
  return p.theme[p.brand];
}, function (p) {
  return p.theme.spacing(2);
});
var DismissButton = styled.button(_templateObject4(), function (p) {
  return p.theme.spacing(3);
}, function (p) {
  return p.theme.spacing(3);
});
var Content = styled.div(_templateObject5(), function (p) {
  return !p.inline ? "width: 368px;" : null;
});
var MessageContent = styled.div(_templateObject6(), function (p) {
  return p.theme.spacing(2);
});
var Span = styled.span(_templateObject7(), function (p) {
  return p.theme.text;
});
var MainMessage = styled(Span)(_templateObject8());
var Link = styled.a(_templateObject9(), function (p) {
  return p.theme.link;
}, function (p) {
  return p.inline ? '0px' : p.theme.spacing(0.5);
});

var getIcon = function getIcon(messageType) {
  switch (messageType) {
    case 'danger':
      return faExclamationTriangle;

    case 'success':
      return faCheck;

    case 'warning':
      return faExclamationCircle;

    case 'info':
    default:
      return faInfoCircle;
  }
};

var Message = function Message(_ref) {
  var _ref$brand = _ref.brand,
      brand = _ref$brand === void 0 ? 'info' : _ref$brand,
      _ref$dismissAfterSeco = _ref.dismissAfterSeconds,
      dismissAfterSeconds = _ref$dismissAfterSeco === void 0 ? 6 : _ref$dismissAfterSeco,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$shouldDisplay = _ref.shouldDisplay,
      shouldDisplay = _ref$shouldDisplay === void 0 ? false : _ref$shouldDisplay,
      _ref$includeLink = _ref.includeLink,
      includeLink = _ref$includeLink === void 0 ? true : _ref$includeLink,
      mainMessage = _ref.mainMessage,
      secondaryMessage = _ref.secondaryMessage,
      linkUrl = _ref.linkUrl,
      linkText = _ref.linkText,
      props = _objectWithoutProperties(_ref, ["brand", "dismissAfterSeconds", "inline", "shouldDisplay", "includeLink", "mainMessage", "secondaryMessage", "linkUrl", "linkText"]);

  var _useState = useState(shouldDisplay),
      _useState2 = _slicedToArray(_useState, 2),
      displayMessage = _useState2[0],
      setDisplayMessage = _useState2[1];

  useEffect(function () {
    if (displayMessage && !inline) {
      var timer = setTimeout(function () {
        setDisplayMessage(false);
      }, dismissAfterSeconds * 1000);
      return function () {
        clearTimeout(timer);
      };
    }

    return undefined; // Run this only once:
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var notSuccess = function notSuccess() {
    return brand !== 'success';
  };

  var displayLink = includeLink && !(inline && brand === 'info') && notSuccess() ? /*#__PURE__*/React.createElement(Link, {
    inline: inline,
    href: linkUrl
  }, linkText) : null;
  return displayMessage && /*#__PURE__*/React.createElement(Wrapper, _extends({
    brand: brand
  }, props), /*#__PURE__*/React.createElement(InnerPaddedWrapper, null, /*#__PURE__*/React.createElement(Content, {
    inline: inline
  }, /*#__PURE__*/React.createElement(SideWrapper, {
    brand: brand
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: getIcon(brand)
  })), /*#__PURE__*/React.createElement(MessageContent, null, /*#__PURE__*/React.createElement(Span, null, /*#__PURE__*/React.createElement(MainMessage, null, mainMessage, " "), notSuccess() && secondaryMessage), displayLink), !inline && /*#__PURE__*/React.createElement(DismissButton, {
    onClick: function onClick() {
      return setDisplayMessage(false);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: faTimes
  })))));
};

export default Message;